import script from "./FilterGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterGroup.vue?vue&type=script&lang=ts&setup=true"

import "./FilterGroup.vue?vue&type=style&index=0&id=6978103e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6978103e"]])

export default __exports__